<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons>
            <vs-button class="xs:w-full sm:w-auto rounded-lg" :to="{ name: 'export-users' }" >
                {{ $t("apps.registered-users.exportcsv") }}
            </vs-button>
        </template>
        <template v-slot:datatable>
            <Datatable
                :config="datatableConfig"
                :elements="users"
                :stripe="true"
                :draggable="false"
                :sst="true"
                :pagination="pagination"
                @filter="filter"
                @action="handleAction"
            />
        </template>
    </DatatablePageLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import Datatable from '@/modules/Shared/Components/table/SKDataTable.vue'
import loader from "@/modules/Shared/Mixins/loader";
import PaginationService from '@/modules/Shared/Services/PaginationService'
import UsersService from '@/modules/Apps/Services/UsersService'
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout";

const AVATAR_FALLBACK = 'https://userdatacf.skitude.com/images/photo_profile.png'

export default {
    name: 'users',
    components: {
        DatatablePageLayout,
        Datatable
    },
    mixins: [loader],
    data () {
        return {
            users: [],
            datatableConfig: [
                { 'type': 'image', 'field': 'avatar', head: this.$t("profile.label.avatar"), 'searchable': false, 'sortable': false },
                { 'type': 'text', 'field': 'id', head: this.$t("shops.id"), 'searchable': true, 'sortable': false },
                { 'type': 'text', 'field': 'uuid_table', head: 'uuid', 'searchable': true, 'sortable': false },
                { 'type': 'text', 'field': 'username', head: this.$t("apps.registered-users.username"), 'searchable': true, 'sortable': false },
                { 'type': 'text', 'field': 'email', head: this.$t("apps.registered-users.email"), 'searchable': true, 'sortable': false },
                { 'type': 'actions', 'field': 'actions', head: this.$t("geofences.geofences-messages.actions"), 'searchable': false, 'sortable': false }
            ],
            pagination: {},
            parameters: {}
        }
    },
    async created() {
        await this.$store.dispatch('apps/setApp', this.applicationUuid)
        await this.getUsers({})
    },
    computed: {
        ...mapGetters( ['applicationUuid'] ),
        ...mapGetters('apps', ['app']),
        allowsUsersManagement() {
            return this.app(this.applicationUuid).allows_users_management
        }
    },
    methods: {
        async getUsers(parameters) {
            this.parameters = parameters

            await this.load(async () => {
                const usersData = await UsersService.getUsers(this.applicationUuid, parameters)

                this.pagination = {
                    per_page: usersData.per_page,
                    total: usersData.total
                }

                this.users = usersData.data.map(user => ({
                    ...user,
                    'avatar': user.avatar || AVATAR_FALLBACK,
                    'uuid_table': user.uuid.slice(0, 8) + '...',
                    'actions': this.allowsUsersManagement ? [ 'view', 'delete' ] : [ 'view' ]
                }))
            })
        },
        filter(params) {
            this.getUsers(PaginationService.parseParameters(params))
        },
        async handleAction(type, uuid) {
            switch(type) {
                case 'view':
                    await this.$router.push({
                        name: 'user-detail',
                        params: { 'uuid': this.applicationUuid, 'userUuid': uuid }
                    });
                break;
                case 'delete':
                    await this.deleteUser(uuid)
                break;
            }
        },
        async deleteUser(uuid) {
            await this.loadAndNotify(async () => {
                await UsersService.deleteUser(this.applicationUuid, uuid)
                await this.getUsers(this.parameters)
            })
        }
    }
}
</script>
